import React, { useState, useEffect, useRef } from "react";
import "./ProfileBanner.css";
import cameraIcon from "../../../Assets/icons/photo_camera.svg";
import defaultBanner from "../../../Assets/banner-photo.svg";

const Banner = ({ isEditing, savedBanner, onSave }) => {
  const [banner, setBanner] = useState(savedBanner || defaultBanner);
  const [hover, setHover] = useState(false);
  const [contextMenu, setContextMenu] = useState(null);
  const fileInputRef = useRef(null);
  const menuRef = useRef(null);
  const [isDeleted, setIsDeleted] = useState(false); 


  useEffect(() => {
    if (!isEditing) {
      setBanner(savedBanner || defaultBanner);
      setIsDeleted(false);
    }
  }, [isEditing, savedBanner]);

  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setContextMenu(null);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

 
  const handleImageChange = (event) => {
    if (contextMenu) return;
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBanner(reader.result);
        setIsDeleted(false);
      };
      reader.readAsDataURL(file);
    }
  };

  
  const handleBannerClick = () => {
    if (isEditing && !contextMenu) {
      fileInputRef.current.click();
    }
  };

  
  const handleContextMenu = (event) => {
    event.preventDefault();
    if (!isEditing) return;
    setContextMenu({ x: event.pageX, y: event.pageY });
  };


  const handleResetChanges = () => {
    console.log("Reset to default:", defaultBanner); 
    setBanner(defaultBanner);
    setIsDeleted(false);
    setContextMenu(null);
  };

  const handleDeleteImage = () => {
    setBanner(null);
    setIsDeleted(true);
    setContextMenu(null);
  };

  return (
    <div className="banner-container">
      <div
        className={`banner ${isEditing && "editable"} ${hover ? "hovered" : ""}`}
        style={{
          backgroundImage: banner ? `url(${banner})` : "none",
          backgroundColor: isDeleted ? "#1D1A2759" : "transparent",
        }}
        onClick={handleBannerClick}
        onContextMenu={handleContextMenu}
        onMouseEnter={() => isEditing && setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {isEditing && hover && (
          <div className="overlay">
            <span className="camera-icon">
              <img src={cameraIcon} alt="camera" />
            </span>
          </div>
        )}
      </div>

      {contextMenu && (
        <div ref={menuRef} className="context-menu" style={{ top: "40px", left: "923px" }}>
          <div onClick={handleResetChanges}>Reset Changes</div>
          <div onClick={handleDeleteImage}>Delete</div>
        </div>
      )}

      <input type="file" ref={fileInputRef} style={{ display: "none" }} accept="image/*" onChange={handleImageChange} />
    </div>
  );
};

export default Banner;
